import { render } from "./language-tab.vue?vue&type=template&id=1ec3c490&scoped=true&ts=true"
import script from "./language-tab.vue?vue&type=script&lang=ts"
export * from "./language-tab.vue?vue&type=script&lang=ts"

import "./language-tab.vue?vue&type=style&index=0&id=1ec3c490&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec3c490"]])

export default __exports__